import OrderReceiverSearch from "./orderReceiverSearch.container"

export default OrderReceiverSearch;